/** The type of a hook event. */
export var Type;
(function (Type) {
    Type["TriggerHook"] = "TriggerHook";
})(Type || (Type = {}));
